import { IgetBackofficeConfigurationResponse } from '../../../../types/configuration.types';
import UsersPermissionsGroupsSection from './UsersPermissionsGroupsSection/UsersPermissionsGroupsSection';
import AddUserToBackofficeSection from './AddUserToBackofficeSection/AddUserToBackofficeSection';
import RemoveUserAccessToBackofficeSection from './RemoveUserAccessToBackofficeSection/RemoveUserAccessToBackofficeSection';
import './Tab1UsersPermissions.scss';

const Tab1UsersPermissions = ({
  permissionsData,
  updateDataCallback
}: {
  permissionsData?: IgetBackofficeConfigurationResponse;
  updateDataCallback?: () => void;
}) => {
  return (
    <div className="tab1UsersPermissions">
      <AddUserToBackofficeSection updateDataCallback={updateDataCallback} />
      <div className="dividerLine" />
      <RemoveUserAccessToBackofficeSection updateDataCallback={updateDataCallback} />
      <div className="dividerLine" />
      <UsersPermissionsGroupsSection permissionsData={permissionsData} updateDataCallback={updateDataCallback} />
      <div className="marginAtBottom w-20 h-10" />
    </div>
  );
};

export default Tab1UsersPermissions;
